import React from 'react';
import { Box, Flex, Center } from '@chakra-ui/react';
import {
  IoLogoVue,
  IoLogoReact,
  IoLogoPython,
  IoLogoDocker,
} from 'react-icons/io5';
import {
  DiDjango,
  DiHtml5,
  DiCss3,
  DiJavascript,
  DiNodejs,
  DiDrupal,
  DiBootstrap,
} from 'react-icons/di';
import { TbBrandCypress, TbBrandGolang, TbBrandOpenai } from 'react-icons/tb';
import {
  SiPhp,
  SiNextdotjs,
  SiNuxt,
  SiVuetify,
  SiChakraui,
  SiClaude,
  SiGooglegemini,
  SiWordpress,
} from 'react-icons/si';
import { motion } from 'framer-motion';
import './styles/skill.css';
import SectionHeading from './section-heading';

export default function Skill() {
  const iconSize = 60;
  const language = [
    { id: 1, title: 'HTML', icon: <DiHtml5 size={iconSize} /> },
    { id: 2, title: 'CSS', icon: <DiCss3 size={iconSize} /> },
    { id: 3, title: 'JavaScript', icon: <DiJavascript size={iconSize} /> },
    { id: 4, title: 'Python', icon: <IoLogoPython size={iconSize} /> },
    { id: 5, title: 'Php', icon: <SiPhp size={iconSize} /> },
  ];
  const framework = [
    { title: 'Vue.js', icon: <IoLogoVue size={iconSize} /> },
    { title: 'Nuxt.js', icon: <SiNuxt size={iconSize} /> },
    { title: 'React.js', icon: <IoLogoReact size={iconSize} /> },
    { title: 'Next.js', icon: <SiNextdotjs size={iconSize} /> },
    { title: 'Node.js', icon: <DiNodejs size={iconSize} /> },
    { title: 'Django', icon: <DiDjango size={iconSize} /> },
    { title: 'Golang', icon: <TbBrandGolang size={iconSize} /> },
    { title: 'Docker', icon: <IoLogoDocker size={iconSize} /> },
    { title: 'Drupal', icon: <DiDrupal size={iconSize} /> },
    { title: 'WordPress', icon: <SiWordpress size={iconSize} /> },
    { title: 'Cypress', icon: <TbBrandCypress size={iconSize} /> },
    { title: 'Vuetify', icon: <SiVuetify size={iconSize} /> },
    { title: 'Bootstrap', icon: <DiBootstrap size={iconSize} /> },
    { title: 'Chakraui', icon: <SiChakraui size={iconSize} /> },
  ];
  const aiTools = [
    { title: 'Claude', icon: <SiClaude size={iconSize} /> },
    { title: 'Gemini', icon: <SiGooglegemini size={iconSize} /> },
    { title: 'ChatGPT', icon: <TbBrandOpenai size={iconSize} /> },
  ];

  const renderSkillList = (items, keyPrefix) =>
    items.map((item, index) => (
      <motion.div
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        transition={{
          type: 'spring',
          stiffness: 260,
          damping: 20,
        }}
        key={`${keyPrefix}-${index}`}
      >
        <Box className="icon-skill">
          <Center>{item.icon}</Center>
          <Center>{item.title}</Center>
        </Box>
      </motion.div>
    ));

  const languageList = renderSkillList(language, 'languague');
  const framworkList = renderSkillList(framework, 'framework');
  const aiToolList = renderSkillList(aiTools, 'ai-tool');

  return (
    <Box mt={'90px'}>
      <Flex>
        <Box w="100%">
          <SectionHeading index="06">Technical Skills</SectionHeading>
          <Box>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              variants={{
                visible: { opacity: 1, scale: 1 },
                hidden: { opacity: 0, scale: 0.5 },
              }}
            >
              <Box className="skill-grid">{languageList}</Box>
            </motion.div>
            <Box className="eyebrow" marginY={6}>
              Framework &amp; Library
            </Box>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              variants={{
                visible: { opacity: 1, scale: 1 },
                hidden: { opacity: 0, scale: 0.5 },
              }}
            >
              <Box className="skill-grid">{framworkList}</Box>
            </motion.div>
            <Box className="eyebrow" marginY={6}>
              AI Tools
            </Box>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              variants={{
                visible: { opacity: 1, scale: 1 },
                hidden: { opacity: 0, scale: 0.5 },
              }}
            >
              <Box className="skill-grid">{aiToolList}</Box>
            </motion.div>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}
